<template>
  <div>
    <AiChatWidgetBubble
      v-if="aiChatEnabled"
      :active-state="bubbleState"
      @state-change="handleStateChange"
      @first-hover="handleFirstHover"
    />
    <AiChatWidgetSmartDrawer
      :is-open="isOpen"
      :active-state="bubbleState"
      :should-load="loadDrawer"
      :client-info="clientInfo"
      @close="handleDrawerClose"
    />
  </div>
</template>

<script setup>
const { bubbleState, aiChatEnabled, isOpen, loadDrawer, handleStateChange, handleDrawerClose, handleFirstHover } =
  useAiChatWidget();
defineProps({
  clientInfo: {
    type: Object,
    required: true,
  },
});
</script>
